import Message from 'shared_components/message';
import { axiosPhase2API, axiosLabAPI } from 'services/axios';
import HttpCodeMessage from 'shared_components/message_http_status';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchUnitOfMeasureItems() {
	let UnitOfMeasureItems = [];

	try {
		const response = await axiosLabAPI({
			method: API_GET_METHOD,
			url: `settings/unitofmeasure`, 
		});

		const { data } = response;
		UnitOfMeasureItems = data.RECORDS || [];
	} catch (e) {
		showMessage(e);
	}

	return UnitOfMeasureItems;
}

export async function createUnitOfMeasureItems(payload) {
	let createdUnitOfMeasure;

	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url: `settings/unitofmeasure`,
			data: {
				p_unit_measure_code: payload.unitOfMeasureCode,
				p_unit_measure_base: payload.unitOfMeasureBase,
				p_unit_measure_from: payload.unitOfMeasureFrom,
				p_unit_measure_operator: payload.unitOfMeasureOperator,
				p_unit_measure_factor: payload.unitOfMeasureFactor,
				p_is_active: payload.is_active,
			},
		});

		const { data } = response;
		createdUnitOfMeasure = data;
	} catch (e) {
		showMessage(e);
	}
	return createdUnitOfMeasure;
}

export async function updateUnitOfMeasureItems(payload) {
	let updatedUnitOfMeasure;

	try {
		const content = {
			method: API_PUT_METHOD,
			url: `settings/unitofmeasure`,
			data: {
				p_unit_measure_id: payload.unitOfMeasureID,
				p_unit_measure_code: payload.unitOfMeasureCode,
				p_unit_measure_base: payload.unitOfMeasureBase,
				p_unit_measure_from: payload.unitOfMeasureFrom,
				p_unit_measure_operator: payload.unitOfMeasureOperator,
				p_unit_measure_factor: payload.unitOfMeasureFactor,
				p_is_active: payload.is_active,
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		updatedUnitOfMeasure = data;

		// Show success message from API response
		if (data && data.STATUSCODE === 200 && data.MESSAGE) {
			Message.success({ message: data.MESSAGE });
		}
	} catch (e) {
		showMessage(e);
	}

	return updatedUnitOfMeasure;
}

export async function applySorting(payload) {
	let sortResponse;
	const url = `settings/unitofmeasuresorting`;

	try {
		const content = {
			method: API_PUT_METHOD,
			url,
			data: {
				p_unit_of_measure_sorting_array: JSON.stringify(payload)
			},
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		sortResponse = data;

		// Show success message from API response
		if (data && data.STATUSCODE === 200 && data.MESSAGE) {
			Message.success({ message: data.MESSAGE });
		}
	} catch (error) {
		showMessage(error);
	}

	return sortResponse;
}
